"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("primereact/utils");
const react_1 = __importDefault(require("react"));
const no_image_png_1 = __importDefault(require("../../../assets/no-image.png"));
const tooltip_1 = require("primereact/tooltip");
exports.ProductCard = react_1.default.memo(({ product, isSelected, onClick }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { onClick: () => onClick(product.micronProductId), className: (0, utils_1.classNames)('flex flex-col items-center p-4 rounded-lg shadow-lg border transition-all duration-200 cursor-pointer', {
            'border-blue-500 bg-blue-50': isSelected,
            'border-gray-200 hover:border-gray-400': !isSelected,
        }), children: [(0, jsx_runtime_1.jsx)("img", { loading: "lazy", src: product.imgUrl || no_image_png_1.default, alt: product.name, onError: (e) => {
                    e.currentTarget.src = no_image_png_1.default;
                }, className: "w-32 h-32 object-cover rounded-t-lg" }), (0, jsx_runtime_1.jsx)("div", { className: "text-center mt-2 font-semibold truncate max-w-[100%]", "data-pr-tooltip": product.name, children: product.name }), (0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: "div[data-pr-tooltip]" })] }));
});
